import dayjs from 'dayjs';
import zhCN from 'dayjs/locale/zh-cn';
import Utc from 'dayjs/plugin/utc';
// 设置语言
dayjs.locale(zhCN);

// 配置 UTC 插件，兼容 Utc 字符串时间处理
dayjs.extend(Utc);
